import React, {Component} from 'react';
import {Grid} from "@mui/material";
import '../login/Login.css'
import {NavLink, useNavigate} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";

import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import Recaptcha from "react-google-recaptcha";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import CopyRightLinkRaiko from "../../raikoComponents/copyRightLinkRaiko/CopyRightLinkRaiko";
import AppBrand from "../../component/appBrand/AppBrand";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import DarkModeToggle from "../../component/darkModeToggle/DarkModeToggle";
import {readToken} from "../../service/authService/AuthService";


const ForgetPassword = () => {

    const token = readToken()
    const navigate = useNavigate()

    useEffect(() => {
        if (typeof token !== "undefined" && token !== null) {
            navigate(RouteInfo.Root.url)
        }
    }, [token])

    const snackbarState = useSnackbarDispatcher()
    const [isVerified, setIsVerified] = useState(false);
    const verifyCallback = () => {
        setIsVerified(true)
    }


    return (
        <Grid xs={12} id="login-container">
            <section className="loginCardContainer default-card-container-background-style">
                <div className="loginCardBody">
                    <AppBrand/>

                    <span className={css`
                      font-size: 16px;
                      margin-bottom: .5rem;
                      width: 100%;
                      text-align: center;
                      color: var(--color-text);
                      transition: var(--base-transition);
                    `}>
                        پنل مدیریت رایکو
                    </span>
                    <span className={css`
                      font-size: 14px;
                      margin-bottom: 1.5rem;
                      width: 100%;
                      text-align: center;
                      color: var(--color-text);
                      transition: var(--base-transition);
                    `}>
                        لطفا برای بازیابی رمز عبور مشخصات زیر را وارد نمایید.
                    </span>

                    <RaikoMaterialOutlinedInput
                        labelText="نام کاربری"
                        placeHolder="نام کاربری خود را وارد نمایید"
                        spellCheck="false"
                        inputId="username"
                        className={css`margin-bottom: .5rem !important;`}
                    />

                    <RaikoMaterialOutlinedInput
                        labelText="کد ملی"
                        placeHolder="کد ملی خود را وارد نمایید"
                        spellCheck="false"
                        inputId="nationalCode"
                        className={css`margin-bottom: .5rem !important;`}
                    />

                    <RaikoMaterialOutlinedInput
                        labelText="شماره همراه"
                        placeHolder="شماره همراه خود را وارد نمایید"
                        spellCheck="false"
                        inputId="phoneNumber"
                        className={css`margin-bottom: 1rem !important;`}
                    />

                    <div
                        className={css`
                          width: 100%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-bottom: 1rem;
                        `}>
                        {/*<Recaptcha
                            className='g-recaptcha'
                            sitekey="6LdSrsIdAAAAAJWB5uD9NHtN5LVfoP2ENrOjvLOW"
                            render="explicit"
                            onChange={verifyCallback}
                            hl="fa"
                        />*/}
                    </div>


                    <ButtonPrimaryRaiko
                        className={css`
                          width: 100%;
                          margin-bottom: 1rem !important;
                        `}
                        onClick={() => {
                            navigate(RouteInfo.ConfirmPhoneNumber.globalUrl)

                            // if (isVerified)
                            //     navigate(RouteInfo.ConfirmPhoneNumber.globalUrl)
                            // else
                            //     snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "لطفا برای بازیابی رمز عبور \"من ربات نیستم\" را تایید نمایید"))
                        }}
                        label="ارسال کد تایید"
                    />

                    <NavLink
                        className={css`
                          font-size: var(--text-size-min);
                          margin-bottom: 1.5rem;
                          color: var(--color-variant);

                          &:hover {
                            color: var(--color-text) !important;
                          }
                        `}
                        to={RouteInfo.Login.globalUrl}
                    >
                        بازگشت به صفحه ورود
                    </NavLink>

                    <CopyRightLinkRaiko/>
                </div>

            </section>

            <div className={css`display: flex;
              align-items: start;
              margin-top: 1rem;
            `}>
                <DarkModeToggle/>
            </div>

        </Grid>
    )
}
export default ForgetPassword;